import script from "./SchoolsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolsView.vue?vue&type=script&setup=true&lang=js"

import "./SchoolsView.vue?vue&type=style&index=0&id=f1be51f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1be51f0"]])

export default __exports__